module.exports = __webpack_public_path__ + "images/fa-refer-a-friend.jpg";